import { render } from "./SendToPartnerPage.vue?vue&type=template&id=222d76e2&scoped=true&ts=true"
import script from "./SendToPartnerPage.vue?vue&type=script&lang=ts"
export * from "./SendToPartnerPage.vue?vue&type=script&lang=ts"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css"
import "./SendToPartnerPage.vue?vue&type=style&index=1&id=222d76e2&scoped=true&lang=css"
import "./SendToPartnerPage.vue?vue&type=style&index=2&id=222d76e2&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222d76e2"]])

export default __exports__